<script>
  export var settings;

  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
  } from "sveltestrap";
  import { Form, FormGroup, FormText, Label } from "sveltestrap";

  // import { from } from './from'
  // from("/recs", {}).then(r=>r.json()).then(json => {
  //   console.log("/recs", json);
  // })
</script>

User settings
<Form class="pt-2">
  <InputGroup>
    <InputGroupAddon addonType="prepend">
      <InputGroupText>Region</InputGroupText>
    </InputGroupAddon>
    <Input placeholder="eu-west-1" value={settings.region} readonly />
  </InputGroup>
</Form>
